import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StoreLayout } from '@/components/layout/StoreLayout';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

export default function OrderSuccess() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const orderNumber = params.get('n') || '';

  return (
    <StoreLayout>
      <div className="container mx-auto py-24 text-center max-w-lg px-4">
        <motion.div
          initial={{ scale: 0, rotate: -90 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 12 }}
        >
          <div className="relative inline-flex items-center justify-center mb-6">
            <div className="absolute inset-0 rounded-full bg-primary/10 blur-xl" />
            <CheckCircle2 className="w-24 h-24 text-primary relative z-10" strokeWidth={1.5} />
          </div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.5 }}
        >
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4 text-foreground">
            {t('orderSuccess.title')}
          </h1>
          <p className="text-muted-foreground text-lg mb-2">
            {t('orderSuccess.subtitle')}
          </p>
          <p className="text-foreground/80 font-medium mb-10">
            {t('orderSuccess.contactSoon')}
          </p>
          
          {orderNumber && (
            <div className="inline-block bg-background/50 backdrop-blur-md rounded-xl px-8 py-5 mb-10 border border-border/50 shadow-sm">
              <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">
                {t('orderSuccess.orderNumber')}
              </p>
              <p className="font-display text-2xl font-bold text-foreground tracking-wider">
                {orderNumber}
              </p>
            </div>
          )}
          
          <div>
            <Button asChild size="lg" className="h-12 px-8 text-base rounded-full shadow-sm">
              <Link to="/">{t('orderSuccess.backHome')}</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </StoreLayout>
  );
}
